<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Access Requests</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Status</mat-label>
    <mat-select [(ngModel)]="filter_options.status" matTooltip="Filter requests by their approval status." name="status">
      <mat-option *ngFor="let option of statusOptions" [value]="option.value">{{ option.label }}</mat-option>
    </mat-select>
    <mat-hint>
      Declined requests can still be approved, which is how you let somebody in who has run out of
      attempts to ask again.
    </mat-hint>
  </mat-form-field>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-center my-2 py-2">
  <div class="p-2">
    <button type="button" mat-raised-button color="primary" (click)="onSaveAndClose()">
      <mat-icon>filter_list</mat-icon> Apply Filter
    </button>
  </div>
  <div class="p-2">
    <button type="button" mat-raised-button color="secondary" (click)="onClearAndClose()">
      <mat-icon>clear_all</mat-icon> Clear Filter
    </button>
  </div>
</mat-dialog-actions>
